import { GetLoadables } from './loader';
// #if process.env.UIX_CHUNKED === 'true'
let loader = ()=>{
    return import(/* webpackChunkName: 'rvirtualized' */ './rvirtualizedLoad');
};
const L = GetLoadables(loader, [
    'AutoSizer',
    'Collection',
    'List'
]);
// #endif
// #if process.env.UIX_CHUNKED === 'false'
// import * as L from './rvirtualizedLoad'
// #endif
export let { AutoSizer, Collection, List } = L;
